import AxiosInstance from "../../utils/AxiosInstance";
import { ProductDetailInterface } from "./models/ProductDetailInterface";

const API_ROUTE = "products";
export const getProductList = async (params : any) => {
  const prm = new URLSearchParams(params).toString()
  return await AxiosInstance.get(`/${API_ROUTE}?${prm}`);
};

export const getProductDetail = async (index: string) => {
  return await AxiosInstance.get(`/${API_ROUTE}/${index}`);
};

export const createProduct = async (data: ProductDetailInterface) => {
  const formData = new FormData();
  const keys = Object.keys(data);
  for (var i = 0; i < keys.length; i++) {
    formData.append(keys[i], data[keys[i]]);
  }

  return await AxiosInstance.post(`/${API_ROUTE}`, formData);
};

export const deleteProduct = async (index: string) => {
  return await AxiosInstance.delete(`/${API_ROUTE}/${index}`);
};
export const updateProduct = async (index: string, data: ProductDetailInterface) => {
  return await AxiosInstance.post(`/${API_ROUTE}/${index}`, data);
};
